import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  Context,
  fetchClasses,
  fetchStudents,
  fetchSubClasses,
  subClassesPath,
  updateSubClassStudents,
  UPDATE_SUB_CLASS_STUDENT_SUCCESS_MESSAGE,
} from "../../../managerStore";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import EditSubClassStudentForm from "../../../templates/manager/EditSubClassStudentForm";

export default (props: { match: { params: { id: string } } }) => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const id = parseInt(props.match.params.id, 10);
  const history = useHistory();
  const { currentYear } = useCurrentYear();

  React.useEffect(() => {
    if (state.success_message === UPDATE_SUB_CLASS_STUDENT_SUCCESS_MESSAGE) {
      history.push(subClassesPath);
    }
  }, [history, state.success_message]);

  React.useEffect(() => {
    dispatch(fetchClasses(currentYear));
    dispatch(fetchSubClasses());
    dispatch(fetchStudents({ for_gear: true, include_teacher: true }));
  }, [dispatch, currentYear]);

  const updateSubClassStudentsFunc = React.useCallback(
    (student_ids: number[]) => {
      dispatch(peep(updateSubClassStudents(id, student_ids)));
    },
    [dispatch, peep, id],
  );

  const sub_class = state.sub_classes.filter(cls => cls.id === id)[0];

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.subClasses, to: subClassesPath }]}
        currentTitle={titles.editSubClassStudent}
      />
      <EditSubClassStudentForm
        title={titles.editSubClassStudent}
        calling={calling}
        students={state.students}
        student_ids={state.students
          .filter(s => s.sub_class_ids?.indexOf(id) !== -1)
          .map(s => s.id)}
        classes={state.classes}
        sub_class={sub_class}
        updateSubClassStudents={updateSubClassStudentsFunc}
      />
    </div>
  );
};
